module.exports = __webpack_public_path__ + "img/4.fc6501b4.jpg";